import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getInvoicingExpensesInsightsApi,
  getInvoicingRevenueInsightsApi,
} from "@/apis/insightsApi";

import type { InvoicingInsightsPayload } from "@/commonTypes/insightsTypes";

export const getInvoicingRevenueInsightsAction = createAsyncThunk(
  "insights/revenueInsights",
  async (data: InvoicingInsightsPayload) => {
    const response = await getInvoicingRevenueInsightsApi(data);
    return response.data;
  }
);

export const getInvoicingExpensesInsightsAction = createAsyncThunk(
  "insights/expensesInsights",
  async (data: InvoicingInsightsPayload) => {
    const response = await getInvoicingExpensesInsightsApi(data);
    return response.data;
  }
);
